import { render, staticRenderFns } from "./Works.vue?vue&type=template&id=773d8c45&scoped=true"
import script from "./Works.vue?vue&type=script&lang=js"
export * from "./Works.vue?vue&type=script&lang=js"
import style0 from "./Works.vue?vue&type=style&index=0&id=773d8c45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773d8c45",
  null
  
)

export default component.exports